var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4536 12L14.5269 16.073C14.6652 16.2115 14.7361 16.3856 14.7394 16.5953C14.7426 16.8048 14.6717 16.982 14.5269 17.127C14.3819 17.2718 14.2062 17.3443 13.9999 17.3443C13.7936 17.3443 13.6179 17.2718 13.4729 17.127L8.97865 12.6328C8.88515 12.5391 8.81915 12.4403 8.78065 12.3365C8.74215 12.2327 8.7229 12.1205 8.7229 12C8.7229 11.8795 8.74215 11.7673 8.78065 11.6635C8.81915 11.5597 8.88515 11.4609 8.97865 11.3673L13.4729 6.873C13.6114 6.73467 13.7855 6.66384 13.9952 6.6605C14.2046 6.65734 14.3819 6.72817 14.5269 6.873C14.6717 7.018 14.7442 7.19367 14.7442 7.4C14.7442 7.60634 14.6717 7.782 14.5269 7.927L10.4536 12Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlack);
export default __webpack_public_path__ + "static/media/left_black.4305681374a0fa44eb84e7c91d68cbca.svg";
export { ForwardRef as ReactComponent };